var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home page noselect" },
    [
      _c("div", { staticClass: "spacer-25" }),
      _c("MyAbholzeiten"),
      _c("fix-basket"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }